/* SeatFit vehicle lookup: ?year&make&model (display names or slugs) -> the covered generations and fitment rows
 * of one product kind. Loaded `defer` right after seatfit-core.js by snippets/seatfit-config.liquid. */
(function () {
  'use strict';
  var SF = window.SeatFit;
  if (!SF) { console.warn('[SeatFit] seatfit-core.js must load before seatfit-core-resolve.js'); return; }
  if (SF.resolve) return; // second copy of the tag

  var slugify = SF.slugify, toYear = SF.toYear, findBy = SF.findBy;

  function inRanges(ranges, year) {
    return (ranges || []).some(function (r) { return r[0] <= year && year <= r[1]; });
  }

  // Every year the model covers, newest first (what the Year select offers).
  function yearsOf(ranges) {
    var seen = {};
    (ranges || []).forEach(function (r) { for (var y = r[0]; y <= r[1]; y++) seen[y] = true; });
    return Object.keys(seen).map(Number).sort(function (a, b) { return b - a; });
  }

  // status 'ok' | 'unsupported' (make-not-found, model-not-found, year-out-of-range) | 'none'
  // (incomplete: make or model missing; no-year: a known model but no year, e.g. the vehicle
  // cards link without one, so ctx.years lists the choices; load-failed: our data could not load).
  // kind: whose data to read ('seat' | 'cover' | 'mat', default the page's). A cover or mat context says so in
  // ctx.kind and carries its price tiers in ctx.tiers; a seat context has neither, the shape it always had.
  function resolve(q, kind) {
    q = q || {};
    var kc = SF.kindConfig(kind);
    var ctx = { status: 'none', year: toYear(q.year), make: null, model: null, gens: [], rows: [] };
    if (kc.kind !== 'seat') ctx.kind = kc.kind;
    var makeS = slugify(q.make);
    var modelS = slugify(q.model);
    function stop(status, reason) { ctx.status = status; if (reason) ctx.reason = reason; return ctx; }
    if (!makeS && !modelS) return Promise.resolve(stop('none', 'incomplete'));
    return SF.loadIndex(kc.kind).then(function (idx) {
      if (!idx) return stop('none', 'load-failed');
      if (ctx.kind) ctx.tiers = idx.tiers || {};
      var mk = findBy(idx.makes, makeS);
      if (!mk) return makeS ? stop('unsupported', 'make-not-found') : stop('none', 'incomplete');
      ctx.make = { s: mk.s, n: mk.n };
      var mi = findBy(mk.models, modelS);
      if (!mi) return modelS ? stop('unsupported', 'model-not-found') : stop('none', 'incomplete');
      ctx.model = { s: mi.s, n: mi.n };
      ctx.years = yearsOf(mi.y);
      if (ctx.year == null) return stop('none', 'no-year');
      // The index already knows the covered years, so an impossible year skips the make download.
      if (!inRanges(mi.y, ctx.year)) return stop('unsupported', 'year-out-of-range');
      return SF.loadMake(mk.s, kc.kind).then(function (file) {
        var m = file && file.models && file.models[mi.s];
        // The index lists this model, so a missing file or entry is our publishing fault (e.g. the
        // CDN lagging a push), never "we don't cover your car".
        if (!m) {
          ctx.error = file ? 'model missing from make file' : 'make file not found';
          return stop('none', 'load-failed');
        }
        // One year can sit in two generations (changeover years), so keep every match.
        ctx.gens = (m.gens || []).filter(function (g) { return g.y[0] <= ctx.year && ctx.year <= g.y[1]; });
        if (!ctx.gens.length) return stop('unsupported', 'year-out-of-range');
        ctx.gens.forEach(function (g) {
          (g.rows || []).forEach(function (r) {
            // Rows carry their generation so the rules and the cart never have to look it up.
            ctx.rows.push(Object.assign({}, r, { g: g.g, d: g.d || '', gy: g.y }));
          });
        });
        return stop('ok');
      });
    }).catch(function (e) {
      // A failed download is not "we don't cover your car": stay neutral so the UI offers the picker.
      console.warn('[SeatFit] vehicle data failed to load', e);
      ctx.error = String((e && e.message) || e);
      return stop('none', 'load-failed');
    });
  }

  SF.resolve = resolve;
})();
